import React from 'react';
import {Box} from "@mui/material";
import Dots from "./Dots/Dots";

const Loading = () => (
    <Box display={'flex'} width={'100%'} justifyContent={'center'} alignContent={'center'} style={{minHeight: '50vh', flexWrap: 'wrap'}} py={2}>
        <Dots/>
    </Box>
);
export default Loading;